import React from 'react';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate,useParams } from 'react-router-dom';
import './App.css';
import logo from "./logo.png"
import logoblack from "./logoblack.png"
import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import AdminPortal from './Admin.js';
// Navigation Component
const Navigation = () => {
  const navigate = useNavigate();

  return (
    <nav className="main-nav">
      <div className="nav-container">
        <Link to="/" className="logo">
          <img src={logo} alt="ScaleUp" className="logo-img" />
        </Link>
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/samples">Samples</Link>
          <button onClick={() => navigate('/inquiry')} className="cta-btn">
            <span className="material-icons">mail</span>
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>ScaleUp</h4>
          <p>Your business, scaled by us.</p>
          <div className="social-links">
            <a href="mailto:scaleupbuild@proton.me"><span className="material-icons">email</span></a>
            <a href="/inquiry"><span className="material-icons">support_agent</span></a>
          </div>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/about">About Us</Link>
          <Link to="/services">Services</Link>
          <Link to="/samples">Our Work</Link>
          <Link to="/inquiry">Contact</Link>
        </div>
        <div className="footer-section">
          <h4>Contact</h4>
          <p><span className="material-icons">email</span> scaleupbuild@proton.me</p>

        </div>
        <div className="footer-section">
          <h4>Socials</h4>
          <a
            href="https://www.instagram.com/scaleup.build/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              textDecoration: "none",
              marginTop: "10px"
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
              alt="Instagram"
              style={{ width: "28px", height: "28px" }}
            />
            @scaleup.build
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              textDecoration: "none",
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6f/Logo_of_Twitter.svg"
              alt="Twitter"
              style={{ width: "28px", height: "28px" }}
            />
            @scaleupbuild
          </a>

          
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 ScaleUp. All rights reserved.</p>
      </div>
    </footer>
  );
};

// Home Page
const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="page home-page">
      <section className="hero">
        <div className="hero-content">
          <h1>Scale Your <span className="gradient-text">Digital Presence</span></h1>
          <p>Full-stack development, brand strategy, social media marketing, and custom web solutions that drive growth for modern businesses</p>
          <div className="hero-buttons">
            <button onClick={() => navigate('/samples')} className="primary-btn">
              <span className="material-icons">visibility</span>
              View Samples
            </button>
            <button onClick={() => navigate('/inquiry')} className="secondary-btn">
              <span className="material-icons">rocket_launch</span>
              Get Started
            </button>
          </div>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <span className="material-icons">verified</span>
            <h3>50+</h3>
            <p>Projects Delivered</p>
          </div>
          <div className="stat">
            <span className="material-icons">sentiment_satisfied</span>
            <h3>100%</h3>
            <p>Client Satisfaction</p>
          </div>
          <div className="stat">
            <span className="material-icons">support_agent</span>
            <h3>24/7</h3>
            <p>Support</p>
          </div>
        </div>
      </section>

      <section className="features">
        <h2>What We Do</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="material-icons">web</span>
            <h3>Custom Websites</h3>
            <p>Beautiful, responsive websites tailored to your brand identity and business goals</p>
          </div>
          <div className="feature-card">
            <span className="material-icons">apps</span>
            <h3>Full-Stack Applications</h3>
            <p>End-to-end custom web and mobile applications built with cutting-edge technology</p>
          </div>
          <div className="feature-card">
            <span className="material-icons">campaign</span>
            <h3>Social Media Marketing</h3>
            <p>Strategic social media campaigns that amplify your brand and drive engagement</p>
          </div>
          <div className="feature-card">
            <span className="material-icons">lightbulb</span>
            <h3>Brand Strategy</h3>
            <p>Comprehensive brand positioning and strategy to make your business stand out</p>
          </div>
          <div className="feature-card">
            <span className="material-icons">security</span>
            <h3>Secure & Scalable</h3>
            <p>Enterprise-grade security and cloud infrastructure that grows with your business</p>
          </div>
          <div className="feature-card">
            <span className="material-icons">trending_up</span>
            <h3>Growth Focused</h3>
            <p>Data-driven solutions optimized for conversions and business growth</p>
          </div>
        </div>
      </section>

<section className="ai-services">
  <div className="ai-hero">
    <h2>Innovating the <span className="gradient-text">Future with AI</span></h2>
    <p className="ai-subtitle">AI Solutions Built to Scale</p>
  </div>
  
  <div className="ai-grid">
    <div className="ai-card">
      <div className="ai-icon">
        <span className="material-icons">stars</span>
      </div>
      <h3>Custom AI Bots</h3>
      <p>Smart AI bots tailored to your business needs and workflows.</p>
    </div>
    
    <div className="ai-card">
      <div className="ai-icon">
        <span className="material-icons">chat</span>
      </div>
      <h3>WhatsApp AI Integration</h3>
      <p>Automate conversations, support, and sales directly on WhatsApp.</p>
    </div>
    
    <div className="ai-card">
      <div className="ai-icon">
        <span className="material-icons">code</span>
      </div>
      <h3>AI SDKs</h3>
      <p>Developer-friendly SDKs to integrate AI into any app or platform.</p>
    </div>
    
    <div className="ai-card">
      <div className="ai-icon">
        <span className="material-icons">support_agent</span>
      </div>
      <h3>AI Customer Support</h3>
      <p>Automate conversations, support, and sales with intelligent AI agents.</p>
    </div>
    
    <div className="ai-card">
      <div className="ai-icon">
        <span className="material-icons">api</span>
      </div>
      <h3>AI APIs</h3>
      <p>Scalable APIs powering real-time, intelligent automation.</p>
    </div>
    
    <div className="ai-card">
      <div className="ai-icon">
        <span className="material-icons">mail</span>
      </div>
      <h3>AI Email & Ticket Routing</h3>
      <p>Smart AI that classifies, prioritizes, and routes requests automatically.</p>
    </div>
  </div>
</section>

<section className="cta-section">
  <h2>Ready to Scale Your Business?</h2>
  <p>Let's build something amazing together</p>
  <button onClick={() => navigate('/inquiry')} className="large-cta">
    <span className="material-icons">send</span>
    Start Your Project
  </button>
</section>
    </div>
  );
};

// About Page
const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="page about-page">
      <section className="about-hero">
        <h1>About ScaleUp</h1>
        <p className="subtitle">Building digital excellence through strategy, design, and technology</p>
      </section>

      <section className="about-content">
        <div className="about-grid">
          <div className="about-text">
            <h2>Our Story</h2>
            <p>ScaleUp was founded with a comprehensive mission: to help businesses of all sizes establish a powerful digital presence through strategic branding, custom development, and targeted marketing. We believe that every business deserves not just a beautiful website, but a complete digital ecosystem that drives real results.</p>
            <p>Our team of passionate developers, designers, brand strategists, and marketing experts work together to create digital experiences that matter. From custom full-stack applications to social media campaigns, we build growth engines for your business.</p>
          </div>
          <div className="about-image">
            <img src={logoblack} style={{ width: 350, borderRadius: 30 }} alt="ScaleUp Logo" />
          </div>
        </div>
      </section>

      <section className="values">
        <h2>Our Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <span className="material-icons">star</span>
            <h3>Quality First</h3>
            <p>We never compromise on quality. Every line of code, every pixel, every campaign matters.</p>
          </div>
          <div className="value-card">
            <span className="material-icons">handshake</span>
            <h3>Client Partnership</h3>
            <p>Your success is our success. We're in this together.</p>
          </div>
          <div className="value-card">
            <span className="material-icons">lightbulb</span>
            <h3>Innovation</h3>
            <p>Always exploring new technologies and pushing boundaries.</p>
          </div>
          <div className="value-card">
            <span className="material-icons">speed</span>
            <h3>Speed & Efficiency</h3>
            <p>Fast delivery without sacrificing quality.</p>
          </div>
        </div>
      </section>
{/*}
      <section className="team">
        <h2>Meet the Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <span className="material-icons">code</span>
            <h3>Development Team</h3>
            <p>Expert coders crafting robust solutions</p>
          </div>
          <div className="team-member">
            <span className="material-icons">brush</span>
            <h3>Design Team</h3>
            <p>Creative minds bringing ideas to life</p>
          </div>
          <div className="team-member">
            <span className="material-icons">analytics</span>
            <h3>Strategy Team</h3>
            <p>Data-driven planners optimizing growth</p>
          </div>
        </div>
      </section>

      */}
    </div>
  );
};

// Services Page
const ServicesPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const services = [
    {
      title: "Custom Websites",
      icon: "web",
      description: "Professional websites built with modern technology",
      features: ["Responsive Design", "Fast Loading", "SEO Optimized", "Mobile First"]
    },
    {
      title: "Full-Stack Applications",
      icon: "terminal",
      description: "End-to-end custom web and mobile applications",
      features: ["Custom Backend", "Database Design", "API Development", "Cloud Deployment"]
    },
    {
      title: "Social Media Marketing",
      icon: "campaign",
      description: "Strategic campaigns that drive engagement and growth",
      features: ["Content Strategy", "Campaign Management", "Analytics & Reporting", "Community Management"]
    },
    {
      title: "Brand Strategy",
      icon: "palette",
      description: "Comprehensive brand positioning and identity",
      features: ["Brand Identity", "Market Positioning", "Visual Guidelines", "Brand Voice"]
    },
    {
      title: "E-Commerce Solutions",
      icon: "shopping_cart",
      description: "Complete online store setup and management",
      features: ["Payment Integration", "Inventory Management", "Order Tracking", "Analytics"]
    },
    {
      title: "AI Chat Integration",
      icon: "chat",
      description: "Smart chatbots for customer support",
      features: ["24/7 Support", "Natural Language", "Multi-lingual", "Custom Training"]
    },
    {
      title: "Web Applications",
      icon: "apps",
      description: "Complex web apps tailored to your needs",
      features: ["Custom Features", "Scalable Architecture", "API Integration", "Cloud Hosting"]
    },
    {
      title: "Digital Marketing",
      icon: "trending_up",
      description: "SEO and marketing to drive traffic",
      features: ["SEO Optimization", "Content Strategy", "Social Media", "Analytics"]
    },
    {
      title: "Maintenance & Support",
      icon: "support",
      description: "Ongoing support and updates",
      features: ["Regular Updates", "Bug Fixes", "Performance Monitoring", "24/7 Support"]
    }
  ];

  return (
    <div className="page services-page">
      <section className="services-hero">
        <h1>Our Services</h1>
        <p>Comprehensive digital solutions for your business - from strategy to execution</p>
      </section>

      <section className="services-grid-section">
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <span className="material-icons service-icon">{service.icon}</span>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, i) => (
                  <li key={i}><span className="material-icons">check_circle</span> {feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="ai-services">
        <div className="ai-hero">
          <h2>Innovating the <span className="gradient-text">Future with AI</span></h2>
          <p className="ai-subtitle">AI Solutions Built to Scale</p>
        </div>
        
        <div className="ai-grid">
          <div className="ai-card">
            <div className="ai-icon">
              <span className="material-icons">stars</span>
            </div>
            <h3>Custom AI Bots</h3>
            <p>Smart AI bots tailored to your business needs and workflows.</p>
          </div>
          
          <div className="ai-card">
            <div className="ai-icon">
              <span className="material-icons">chat</span>
            </div>
            <h3>WhatsApp AI Integration</h3>
            <p>Automate conversations, support, and sales directly on WhatsApp.</p>
          </div>
          
          <div className="ai-card">
            <div className="ai-icon">
              <span className="material-icons">code</span>
            </div>
            <h3>AI SDKs</h3>
            <p>Developer-friendly SDKs to integrate AI into any app or platform.</p>
          </div>
          
          <div className="ai-card">
            <div className="ai-icon">
              <span className="material-icons">support_agent</span>
            </div>
            <h3>AI Customer Support</h3>
            <p>Automate conversations, support, and sales with intelligent AI agents.</p>
          </div>
          
          <div className="ai-card">
            <div className="ai-icon">
              <span className="material-icons">api</span>
            </div>
            <h3>AI APIs</h3>
            <p>Scalable APIs powering real-time, intelligent automation.</p>
          </div>
          
          <div className="ai-card">
            <div className="ai-icon">
              <span className="material-icons">mail</span>
            </div>
            <h3>AI Email & Ticket Routing</h3>
            <p>Smart AI that classifies, prioritizes, and routes requests automatically.</p>
          </div>
        </div>
      </section>

      <section className="process">
        <h2>Our Process</h2>
        <div className="process-steps">
          <div className="step">
            <div className="step-number">1</div>
            <span className="material-icons">search</span>
            <h3>Discovery & Strategy</h3>
            <p>Understanding your vision, goals, and developing a comprehensive strategy</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <span className="material-icons">design_services</span>
            <h3>Design & Branding</h3>
            <p>Creating stunning mockups, brand identity, and user experiences</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <span className="material-icons">construction</span>
            <h3>Development</h3>
            <p>Building your solution with precision using cutting-edge technology</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <span className="material-icons">rocket_launch</span>
            <h3>Launch & Market</h3>
            <p>Deploying your solution and executing marketing campaigns for growth</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Get Started?</h2>
        <button onClick={() => navigate('/inquiry')} className="large-cta">
          <span className="material-icons">contact_mail</span>
          Contact Us Today
        </button>
      </section>
    </div>
  );
};

// Samples Page
const SamplesPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const samples = [
    {
      title: "Healthcare",
      icon: "local_hospital",
      description: "Professional medical and clinic websites",
      category: "healthcare",
      color: "#2D87F0"
    },
    {
      title: "Restaurants",
      icon: "restaurant",
      description: "Mouth-watering designs for restaurants and cafes",
      category: "restaurants",
      color: "#4ECDC4"
    },
    {
      title: "Fitness & Gym",
      icon: "fitness_center",
      description: "Dynamic websites for fitness centers",
      category: "fitness",
      color: "#AA96DA"
    },
    {
      title: "E-Commerce",
      icon: "storefront",
      description: "Complete online stores with payment integration",
      category: "ecommerce",
      color: "#95E1D3"
    },

   
  ];

  const handleSampleClick = (category) => {
    navigate(`/samples/${category}`);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="page samples-page">
      <section className="samples-hero">
        <h1>Samples</h1>
        <p>Explore our portfolio across different industries</p>
      </section>

      <section className="samples-grid-section">
        <div className="samples-grid">
          {samples.map((sample, index) => (
            <div
              key={index}
              className="sample-card"
              onClick={() => handleSampleClick(sample.category)}
              style={{ '--card-color': sample.color }}
            >
              <div className="sample-icon" style={{ background: sample.color }}>
                <span className="material-icons">{sample.icon}</span>
              </div>
              <h3>{sample.title}</h3>
              <p>{sample.description}</p>
              <button className="view-samples-btn">
                <span className="material-icons">arrow_forward</span>
                View Samples
              </button>
            </div>
          ))}
          <div
              className="sample-card"
              onClick={() => navigate('/inquiry')}
              style={{ '--card-color': 'black' }}
            >
              <div className="sample-icon" style={{ background: 'black' }}>
                <span className="material-icons">apartment</span>
              </div>
              <h3>Other Businesses</h3>
              <p>Dynamic websites for other business types</p>
              <button className="view-samples-btn">
                <span className="material-icons">arrow_forward</span>
                Contact Us for Samples
              </button>
            </div>
        </div>
      </section>
    </div>
  );
};

const SampleDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Optional: list valid files to prevent invalid access
  const validPages = [
    "pet-shops",
    "restaurants",
    "healthcare",
    "ecommerce",
    "real-estate",
    "fitness",
    "salons",
    "education",
    "photography",
    "law-firms",
    "automotive",
    "travel"
  ];

  if (!validPages.includes(id)) {
    return (
      <div style={{ textAlign: "center", padding: "100px 20px" }}>
        <h2>404 - Sample Not Found</h2>
        <button onClick={() => navigate("/samples")}>
          Back to Samples
        </button>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <button
        onClick={() => navigate(-1)}
        style={{
          position: "fixed",
          top: "20px",
          left: "20px",
          zIndex: 1000,
          padding: "10px 15px",
          cursor: "pointer"
        }}
      >
        ← Back
      </button>

      <iframe
        src={`/samples/${id}.html`}
        title={id}
        style={{
          width: "100%",
          height: "100%",
          border: "none"
        }}
      />
    </div>
  );
};




// Main App Component
function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/samples" element={<SamplesPage />} />
          <Route path="/samples/:id" element={<SampleDetailPage />} />
          {/*<Route path="/pricing" element={<PricingPage />} />*/}
          <Route path="/inquiry" element={<InquiryRedirect />} />
          <Route path="/admin" element={<AdminPortal />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

// Redirect component for inquiry form
const InquiryRedirect = ({ category = "general" }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // CONFIGURATION
  const config = {
    general: {
      title: "Contact Us",
      subtitle: "Strategic Solutions for Modern Brands",
      accent: "#000000",
      metricLabel: "Expected Monthly Sales",
      specificField: "Key business offerings / Product line"
    }
  };

  const activeConfig = config[category] || config.general;

  const [formData, setFormData] = useState({
    brandName: '', ownerName: '', email: '', whatsapp: '',
    address: '', budget: '',
    productType: '',
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "all_inquiries"), {
        ...formData,
        category: category,
        timestamp: serverTimestamp()
      });
      setSubmitted(true);
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Error saving data.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  if (submitted) {
    return (
      <div style={styles.pageBackground}>
        <div style={styles.successWrapper}>
          <div style={styles.logoCircle}>
            <span style={{ color: '#fff', fontWeight: 'bold' }}>S</span>
          </div>
          <h2 style={styles.richTitle}>Inquiry Logged.</h2>
          <p style={styles.richSubtitle}>ScaleUp is reviewing your profile.</p>
          <div style={styles.quoteBox}>We will contact you soon.</div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageBackground}>
      <div style={styles.formCard}>


        <div style={styles.header}>
          <h1 style={styles.richTitle}>{activeConfig.title}</h1>
          <p style={styles.richSubtitle}>{activeConfig.subtitle}</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* 01. Identity */}
          <div style={styles.sectionHeader}>01. Identity</div>
          <div style={styles.grid}>
            <input style={styles.richInput} name="brandName" placeholder="Brand Name" onChange={handleChange} required />
            <input style={styles.richInput} name="ownerName" placeholder="Founder / Director" onChange={handleChange} required />
          </div>
          <input style={styles.richInput} name="email" type="email" placeholder="Business Email" onChange={handleChange} required />
          <div style={styles.grid}>
            <input style={styles.richInput} name="whatsapp" placeholder="WhatsApp Number" onChange={handleChange} required />
          </div>

          {/* 02. Business Metrics */}
          <div style={styles.sectionHeader}>02. Business Metrics</div>
          <input style={styles.richInput} name="address" placeholder="Business Address" onChange={handleChange} />
          <div style={styles.grid}>
            <input style={styles.richInput} name="budget" placeholder="Project Budget (optional)" onChange={handleChange} />
            {/*
              <input style={styles.richInput} name="orderVolume" placeholder={activeConfig.metricLabel} onChange={handleChange} />
              */ }

          </div>

          {/* 03. Product Specification */}
          <div style={styles.sectionHeader}>03. Brand Scope</div>
          <textarea style={styles.richTextarea} name="productType" placeholder="Tell us about your business and what services you're interested in (websites, full-stack apps, social media marketing, brand strategy, etc.)" onChange={handleChange} />
          <button type="submit" style={{ ...styles.submitBtn, backgroundColor: activeConfig.accent }} disabled={loading}>
            {loading ? "PROCESSING..." : `SUBMIT INQUIRY`}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  pageBackground: { backgroundColor: '#fdfdfd', minHeight: '100vh', padding: '60px 20px', fontFamily: '"Inter", sans-serif' },
  formCard: { maxWidth: '750px', margin: '0 auto', backgroundColor: '#fff', padding: '40px 60px 60px 60px', borderRadius: '32px', boxShadow: '0 30px 60px rgba(0,0,0,0.06)' },
  brandHeader: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '30px' },
  logoCircle: { width: '80px', height: '80px', borderRadius: '50%', backgroundColor: '#000', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', border: '4px solid #fff', boxShadow: '0 10px 20px rgba(0,0,0,0.08)', marginBottom: '10px' },
  logoImage: { width: '100%', height: '100%', objectFit: 'cover' },
  companyName: { fontSize: '18px', fontWeight: '800', letterSpacing: '2px', textTransform: 'uppercase', color: '#111', margin: 0 },
  header: { textAlign: 'center', marginBottom: '40px' },
  richTitle: { fontSize: '28px', fontWeight: '800', color: '#111', margin: '0' },
  richSubtitle: { color: '#999', fontSize: '11px', marginTop: '8px', textTransform: 'uppercase', letterSpacing: '2px' },
  sectionHeader: { fontSize: '10px', fontWeight: '800', color: '#000', textTransform: 'uppercase', letterSpacing: '3px', marginTop: '40px', marginBottom: '10px', borderBottom: '1px solid #f5f5f5', paddingBottom: '10px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
  richInput: { width: '100%', padding: '15px 0', margin: '10px 0', border: 'none', borderBottom: '1px solid #eee', fontSize: '16px', outline: 'none', backgroundColor: 'transparent' },
  richTextarea: { width: '100%', padding: '15px 0', border: 'none', borderBottom: '1px solid #eee', fontSize: '16px', outline: 'none', resize: 'none', height: '80px' },
  fieldLabel: { display: 'block', marginTop: '25px', fontSize: '13px', fontWeight: '600', color: '#333' },
  richSelect: { width: '100%', padding: '12px', marginTop: '10px', borderRadius: '10px', border: '1px solid #f0f0f0', backgroundColor: '#fafafa' },
  checkboxGroup: { marginTop: '15px', display: 'flex', flexDirection: 'column', gap: '12px' },
  checkLabel: { display: 'flex', alignItems: 'center', fontSize: '14px', color: '#444', cursor: 'pointer', fontWeight: '500' },
  checkbox: { marginRight: '12px', width: '18px', height: '18px', accentColor: '#000' },
  seoGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginTop: '15px' },
  seoCard: { padding: '20px 10px', border: '1px solid #f0f0f0', borderRadius: '16px', cursor: 'pointer', textAlign: 'center', transition: 'all 0.3s ease' },
  seoCardActive: { padding: '20px 10px', color: '#fff', borderRadius: '16px', cursor: 'pointer', textAlign: 'center', transition: 'all 0.3s ease', boxShadow: '0 10px 20px rgba(0,0,0,0.15)' },
  submitBtn: { width: '100%', padding: '22px', color: '#fff', border: 'none', borderRadius: '14px', cursor: 'pointer', fontSize: '15px', fontWeight: '700', letterSpacing: '1px', marginTop: '50px' },
  successWrapper: { textAlign: 'center', padding: '100px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  quoteBox: { display: 'inline-block', marginTop: '20px', padding: '10px 25px', backgroundColor: '#f5f5f5', borderRadius: '50px', fontWeight: '700' }
};

export default App;